import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogueRoutingModule } from './catalogue-routing.module';
import { CatalogueComponent } from './catalogue/catalogue.component';
import { SharedModule } from '../shared/shared.module';
import { CatlogueReferComponent } from './catlogue-refer/catlogue-refer.component';
import { TrackAppPartnerModule } from '../track-app-partner/track-app-partner.module';
@NgModule({
  declarations: [CatalogueComponent, CatlogueReferComponent],
  imports: [
    CommonModule,
    CatalogueRoutingModule,
    TrackAppPartnerModule,
    SharedModule,
  ]
})
export class CatalogueModule { }
